<div class="paywall-card__top">
    <div class="paywall-card__title">
        <h2>
            <ng-content select="[header]"></ng-content>
        </h2>
    </div>
    <div class="paywall-card__description">
        <ng-content select="[description]"></ng-content>
    </div>
    @if (!hidePrice()) {
    <div class="paywall-card__price">
        <ng-content select="[price]"></ng-content>
        <div class="label">
            <span>{{billingPeriodString()}}</span>
        </div>
    </div>
    }
    <div class="paywall-card__button">
        <button (click)="selectCard()">
            <ng-content select="[button]">
                <span>Select</span>
            </ng-content>
        </button>
    </div>
</div>
<div class="paywall-card__bottom">
    <ng-content></ng-content>
</div>